import { AfterViewInit, Component, computed, effect, ElementRef, inject, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TimelineComponent } from "./components/timeline/timeline.component";
import { PointsComponent } from './components/points/points.component';
import { ScrollService } from 'src/app/services/scroll.service';
import { PlannerDayStateService } from '../../services';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { RouteDataService } from '../../../map/services/route-data.service';
// import { RouteTimelineService } from './services/route-timeline.service';
import { DailyRoute } from 'src/app/pages/custom-route/interfaces/custom-route.interface';

@Component({
  selector: 'app-route-timeline',
  standalone: true,
  imports: [
    TranslateModule,
    TimelineComponent,
    PointsComponent
],
  templateUrl: './route-timeline.component.html',
  styleUrls: ['./route-timeline.component.scss'],
})
export class RouteTimelineComponent implements AfterViewInit {  
  public routeTimelineRef = viewChild.required<ElementRef>('routeTimelineRef');
  
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  private _scrollService = inject(ScrollService);
  private _routeDataService = inject(RouteDataService);
  // private _routeTimelineService = inject(RouteTimelineService);

  private readonly _customRouteData = computed(() => this._customRouteService.customRouteData());
  get dailyCustomRouteData(): DailyRoute {
    return this._customRouteData().dailyRoutes[this._dayToShowIndex()];
  }
  get dailyCustomRouteDataDate() {
    return this.dailyCustomRouteData.date;
  }
  private readonly _dayToShowIndex = computed(() => this._plannerDayStateService.dayToShowIndex());
  private readonly _getCurrentTrameIndex = computed(() => this._routeDataService.getCurrentTrameIndex());
  // private readonly now = computed(() => this._routeTimelineService.now());
  
  private _startX = 0;
  
  // setAutoScroll = effect(() => {
  //   this._setupScrollHandlers(this.now());
  // }, { allowSignalWrites: true });
  
  ngAfterViewInit(): void {
    this._setupSwipeHandlers();
  }
  
  /**
   * Logic to handle swipe gestures for navigating between days
   * TODO: REFACTOR THIS CODE TO A SERVICE
   */
  private _setupSwipeHandlers(): void {
    const el = this.routeTimelineRef().nativeElement as HTMLElement;
    if (!el) return;

    // Touch support (mobile)
    el.addEventListener('touchstart', this._onTouchStart);
    el.addEventListener('touchend', this._onTouchEnd);

    // Mouse support (desktop)
    el.addEventListener('mousedown', this._onMouseDown);
    el.addEventListener('mouseup', this._onMouseUp);
  }

  private _onTouchStart = (e: TouchEvent) => {
    this._startX = e.touches[0].clientX;
  };

  private _onTouchEnd = (e: TouchEvent) => {
    const diff = e.changedTouches[0].clientX - this._startX;
    this._handleSwipe(diff);
  };

  private _onMouseDown = (e: MouseEvent) => {
    this._startX = e.clientX;
  };

  private _onMouseUp = (e: MouseEvent) => {
    const diff = e.clientX - this._startX;
    this._handleSwipe(diff);
  };

  private _handleSwipe(diff: number): void {
    if (Math.abs(diff) < 80) return; // minimum swipe distance

    if (diff > 0) {
      // Swipe right → go to the previous day
      this._plannerDayStateService.dayToShowIndex.update(index =>
        index > 0 ? index - 1 : 0
      );
    } else {
      // Swipe left → go to the next day
      const maxIndex = this._customRouteData().dailyRoutes.length - 1;
      this._plannerDayStateService.dayToShowIndex.update(index =>
        index < maxIndex ? index + 1 : maxIndex
      );
    }
  }
  
  private _setupScrollHandlers(now: Date): void {
    const el: HTMLElement =  document.querySelector('app-planner');
    if (!el) return;

    console.log('currentTrameIndex:', this._getCurrentTrameIndex());
    if(this.isSameDay(this.dailyCustomRouteDataDate, now) &&
    this._getCurrentTrameIndex() === undefined) {
      console.log('Auto-scrolling to current hour:', now.getHours());
      const currentHour = now.getHours();
      setTimeout(() => {
        this._scrollService.scrollToElementByTimelineHour(el, currentHour);
      }, 500);
   
    } 
    // else {
    //   console.log('Auto-scrolling to top');
    //   this._scrollService.autoScrollToTop(el);
    //   // console.log('Auto-scrolling to first Element');
    //   // this._scrollService.scrollToElementByTrameIndex(el);
    // }

    this._scrollService.attachScrollListener(el);
    // this._scrollService.scrollToElementByTrameIndex(el, this._getCurrentTrameIndex());
  }

  private isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  
  ngOnDestroy(): void {
    const el = this.routeTimelineRef().nativeElement as HTMLElement;
    if (!el) return;

    el.removeEventListener('touchstart', this._onTouchStart);
    el.removeEventListener('touchend', this._onTouchEnd);
    el.removeEventListener('mousedown', this._onMouseDown);
    el.removeEventListener('mouseup', this._onMouseUp);
    this._scrollService.detachScrollListener();
  }
}
